import { render, staticRenderFns } from "./ClassDocuments.vue?vue&type=template&id=afaf681e&"
import script from "./ClassDocuments.vue?vue&type=script&lang=js&"
export * from "./ClassDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports